import React from 'react';
import './Maintenance.css';

const Maintenance = () => {
  return (
    <div className="maintenance-page">
      <div className="maintenance-container">
        <div className="maintenance-content">
          <div className="maintenance-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2L2 7L12 12L22 7L12 2Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 17L12 22L22 17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 12L12 17L22 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h1 className="maintenance-title">Under Maintenance</h1>
          <p className="maintenance-message">
            We're currently performing scheduled maintenance to improve your experience.
            Please check back soon.
          </p>
          <p className="maintenance-submessage">
            We apologize for any inconvenience this may cause.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;

